// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import './main.css';
// import PieChartComponent from './chart/PieChartComponent';
// import DataTable from './chart/DataTable ';

// const Main = () => {
//   const [onlineData, setOnlineData] = useState([]);
//   const [offlineData, setOfflineData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [tableData, setTableData] = useState([]); // State for table data
//   const [nestedData, setNestedData] = useState(null); // State for nested chart

//   const handleData = async () => {
//     try {
//       const projectResponse = await axios.get(
//         `${process.env.REACT_APP_API_URL}/dashboard-data`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("signIn")}`,
//           },
//         }
//       );
//       const { online, offline } = projectResponse.data;

//       setOnlineData(online || []);
//       setOfflineData(offline || []);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setError("Failed to fetch data. Please try again later.");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     handleData();
//   }, []);

//   return (
//     <>
//     <div id="main" className="flexCol main d-flex flex-row justify-content-between" style={{ gap: '20px' }}>
//       {loading ? (
//         <p>Loading data...</p>
//       ) : error ? (
//         <p>{error}</p>
//       ) : (
//         <>
//           {/* Online Section */}
//           <div className="col-12 col-lg-6 p-3" style={cardStyle}>
//             <div>
//               <p className="fw-bold">Online</p>
//             </div>
//             <hr />
//             <div className="d-flex justify-content-between">
//               {onlineData.length > 0 ? (
//                 <div className="col-sm-12 d-flex justify-content-center">
//                   <PieChartComponent data={{ online: onlineData, offline: [] }} setTableData={setTableData} />
//                 </div>
//               ) : (
//                 <p>No online data available</p>
//               )}
//             </div>
//           </div>

//           {/* Offline Section */}
//           <div className="col-12 col-lg-6 p-3" style={cardStyle}>
//             <div>
//               <p className="fw-bold">Offline</p>
//             </div>
//             <hr />
//             <div className="d-flex justify-content-between">
//               {offlineData.length > 0 ? (
//                 <div className="col-sm-12 d-flex justify-content-center">
//                   <PieChartComponent data={{ online: [], offline: offlineData }} setTableData={setTableData} />
//                 </div>
//               ) : (
//                 <p>No offline data available</p>
//               )}
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//     <div id="main" className='main'>
//        {/* Data Table Section */}
//        {tableData.length > 0 && (
//           <div className="col-12 mt-4">
//             <DataTable data={tableData} />
//           </div>
//         )}
//         </div>
//     </>
//   );
// };

// const cardStyle = {
//   background: "#fff",
//   minHeight: '100%',
//   overflow: 'auto',
//   boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
//   borderRadius: '15px',
//   padding: '20px'
// };

// export default Main;

import axios from "axios";
import React, { useEffect, useState } from "react";
import "./main.css";
import PieChartComponent from "./chart/PieChartComponent";
import DataTable from "./chart/DataTable ";

const Main = () => {
  const [onlineData, setOnlineData] = useState([]);
  const [offlineData, setOfflineData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState([]); // State for table data
  const [secondTableData, setSecondTableData] = useState([]); // State for table data
  const [secondaryChartData, setSecondaryChartData] = useState([]); // State for secondary chart data

  const handleData = async () => {
    try {
      const projectResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/dashboard-data`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        }
      );
      const { online, offline } = projectResponse.data;

      setOnlineData(online || []);
      setOfflineData(offline || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data. Please try again later.");
      setLoading(false);
    }
  };

  useEffect(() => {
    handleData();
  }, []);

  return (
    <>
      <div id="main" className="flexCol main d-flex flex-row justify-content-between" style={{ gap: "20px" }}>
        {loading ? (
          <p>Loading data...</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <>
            {/* Online Section */}
            <div className="col-12 col-lg-6 p-3" style={cardStyle}>
              <div>
                <p className="fw-bold">Online</p>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                {onlineData.length > 0 ? (
                  <div className="col-sm-12 d-flex justify-content-center">
                    <PieChartComponent
                      data={{ online: onlineData, offline: [] }}
                      setTableData={setTableData}
                      tableData={tableData}
                      setSecondaryChartData={setSecondaryChartData} // Pass state updater for secondary chart
              setSecondTableData={setSecondTableData}
                    />
                  </div>
                ) : (
                  <p>No online data available</p>
                )}
              </div>
            </div>

            {/* Offline Section */}
            <div className="col-12 col-lg-6 p-3" style={cardStyle}>
              <div>
                <p className="fw-bold">Offline</p>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                {offlineData.length > 0 ? (
                  <div className="col-sm-12 d-flex justify-content-center">
                    <PieChartComponent
                      data={{ online: [], offline: offlineData }}
                      setTableData={setTableData}
                      tableData={tableData}
                      setSecondaryChartData={setSecondaryChartData} // Pass state updater for secondary chart
                      setSecondTableData={setSecondTableData}

                    />
                  </div>
                ) : (
                  <p>No offline data available</p>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      <div id="main" className="main">
        {/* Data Table Section */}
        {tableData.length > 0 && (
          <div className="col-12">
            <DataTable data={tableData} />
          </div>
        )}

        {/* Secondary Chart Section */}
        {secondaryChartData.length > 0 && (
          <div className="row mt-4">
          <div className="col-12 col-md-6">
            <PieChartComponent
              data={{ online: secondaryChartData, offline: [] }}
              setTableData={setTableData}
              tableData={tableData}
              secondary={true}
              setSecondTableData={setSecondTableData}
            />
          </div>
          <div className="col-12 col-md-6">
            {secondTableData.length > 0 && (
              <div className="col-12 mt-4">
                <DataTable data={secondTableData} secondTable={true} />
              </div>
            )}
          </div>
        </div>
        )}
      </div>
    </>
  );
};

const cardStyle = {
  background: "#fff",
  minHeight: "100%",
  overflow: "auto",
  boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
  borderRadius: "15px",
  padding: "20px",
};

export default Main;
